// @flow strict

import React from 'react';
import { Link } from 'gatsby';

import * as styles from './section-header.module.less';

/**
 * Type of component properties
 */
type SectionHeaderProps = {
  name: string,
  link?: {
    href: string,
    title: string,
  },
};

/**
 * Headline of a section, with a link to
 * detail page of this section.
 *
 * (e.g. category, authors)
 *
 * @param {SectionHeaderProps} props - component properties
 *
 * @returns {Node}
 */
export const SectionHeader = ({ name, link }: SectionHeaderProps) => {
  // if link is available, wrap headline in link
  const headline =
    link == null ? (
      <h3 className={styles.headline}>{name}</h3>
    ) : (
      <Link to={link.href}>
        <h3 className={styles.headline}>{name}</h3>
      </Link>
    );

  return (
    <div className={styles.header}>
      {headline}

      {link != null && (
        <Link to={link.href} className={styles.readMore}>
          {link.title}
        </Link>
      )}
    </div>
  );
};
